import { render, staticRenderFns } from "./Ctest.vue?vue&type=template&id=67468540&"
import script from "./Ctest.vue?vue&type=script&lang=js&"
export * from "./Ctest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports